import React, { useEffect } from 'react'
import { useDrag } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import Box from './Box'
import { ItemTypes } from './utils/ItemTypes'

function getStyles(left, top, height, width, spacing, align, color, isDragging) {
  const transform = `translate3d(${left}px, ${top}px, 0)`

  return {
    position: 'absolute',
    transform,
    height,
    width,
    color,
    letterSpacing: spacing,
    WebkitTransform: transform,
    // IE fallback: hide the real node using CSS when dragging
    // because IE will ignore our custom "empty image" drag preview.
    opacity: isDragging ? 0 : 1
  }
}

export default function DraggableBox({ id, label, left, top, width, height, spacing, color, fontName,
                                       wrap, align, textSize, object, personalizationBoxUrl }) {
  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: ItemTypes.BOX,
      item: { id, left, top, label, width, height, object, wrap },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [id, left, top, width, height, label, spacing, color, fontName, object, wrap],
  )
  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [])
  return (
    <div
      ref={drag}
      style={getStyles(left, top, height, width, spacing, align, color, isDragging)}
      role="DraggableBox"
    >
      <Box title={label} align={align} textSize={textSize} font={fontName} personalizationBoxUrl={personalizationBoxUrl} />
    </div>
  )
}
